import { render, staticRenderFns } from "./BackMenu.vue?vue&type=template&id=2617d6a4&scoped=true&"
import script from "./BackMenu.vue?vue&type=script&lang=js&"
export * from "./BackMenu.vue?vue&type=script&lang=js&"
import style0 from "./BackMenu.scss?vue&type=style&index=0&id=2617d6a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617d6a4",
  null
  
)

export default component.exports